import { encodeData, getUUIDv4 } from './helper'
import { getGeoServerUrl, getGeoServerWorkspace } from '../constant'

const baseURL = process.env.VUE_APP_API_BASE_URL
export function convertLinkToBackEnd(link = '') {
  if (!link) return ''
  if (link.startsWith('http')) {
    return link
  }
  if (link.startsWith('https')) {
    return link
  }
  if (link.startsWith('/static')) {
    return link
  }
  if (link.includes('data:image/png;base64')) {
    return link
  }
  if (link[0] == '/') link = link.substring(1)
  if (!baseURL || baseURL[0] == '/') {
    return `${window.location.origin}/${link}`
  }
  return `${baseURL}${link}`
}
export function convertLayerToGeoserverLink(layerId) {
  let endpoint = getGeoServerUrl()
  let workspace = getGeoServerWorkspace()

  let params = {
    REQUEST: 'GetTile',
    SERVICE: 'WMTS',
    VERSION: '1.0.0',
    LAYER: `${workspace}:${layerId}`,
    TILEMATRIX: 'EPSG:900913:{z}',
    TILEMATRIXSET: 'EPSG:900913',
    FORMAT: 'application/vnd.mapbox-vector-tile',
    TILECOL: '{x}',
    TILEROW: '{y}',
    key: getUUIDv4(),
  }
  let url = `${endpoint}/gwc/service/wmts?${encodeData(params)}`
  return url
}
